import { EventEmitter } from "events";

const configManagerEmitter = new EventEmitter();

export default configManagerEmitter;
